export const STUDY_TIME_BANDS = ['morning', 'afternoon', 'evening'] as const;
export type StudyTimeBand = (typeof STUDY_TIME_BANDS)[number];

/**
 * Horas (formato "HH:MM") agrupadas por franja. Mantenido como objeto
 * para que sea trivial añadir/quitar opciones en el futuro sin tocar
 * el componente. Como las opciones se pintan como chips/tags (no como
 * cards full-width), podemos ofrecer todas las horas en punto del rango
 * sin saturar visualmente.
 */
export const STUDY_TIME_HOURS: Record<StudyTimeBand, readonly string[]> = {
  morning: ['06:00', '07:00', '08:00', '09:00', '10:00', '11:00'],
  afternoon: ['12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00'],
  evening: ['19:00', '20:00', '21:00', '22:00', '23:00'],
};

export interface StudyTimeSelection {
  band: StudyTimeBand;
  /** Hora en formato "HH:MM" (zona Madrid; lo consume `reminderTime`). */
  hour: string;
}

export interface StudyTimeSelectorHandle {
  /** Selección actual, o null si el alumno aún no ha elegido banda+hora. */
  getSelected: () => StudyTimeSelection | null;
  /** True cuando hay banda Y hora seleccionadas. */
  isValid: () => boolean;
}

export interface StudyTimeSelectorProps {
  /** Hora inicial (típicamente `preferences.reminderTime`). */
  defaultHour?: string;
  /** Deshabilita interacciones — típicamente mientras el padre guarda. */
  disabled?: boolean;
  /** Notifica cuando la validez (banda y hora seleccionadas) cambia. */
  onValidityChange?: (isValid: boolean) => void;
}
